import React, { useRef, useState, useEffect } from 'react';
import {
  faChevronLeft,
  faChevronRight,
  faMagnifyingGlass,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { useRouter } from 'next/router';
import forIn from 'lodash/forIn';
// import { toast, ToastContainer } from 'react-toastify';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { makeSelectIsLocaleInPath } from '../MetadataProvider/selectors';
// import I18nLink from '~/components/I18nLink';
import themeVariables from '~/shared/themeVariables';
import config from '~/config';
import LocalStorage from '~/services/LocalStorage';
import { changeKeyword } from '~/containers/Search/actions';
import { searchPhoto } from '~/containers/SearchResultPage/actions';
import I18nRouter from '~/components/I18nRouter';

const OtherKeywords = (props) => {
  const {
    keywords,
    toggleFilterSearch,
    query,
    currentLang,
    t,
    searchPhoto,
  } = props;
  const ref = useRef(null);
  // const router = useRouter();
  const [seeMore, setSeeMore] = useState(false);
  const [showSeeMore, setShowSeeMore] = useState(false);

  useEffect(() => {
    function handleResize() {
      if (ref.current?.scrollHeight > ref.current?.clientHeight) {
        setShowSeeMore(true);
      } else {
        setShowSeeMore(false);
      }
    }
    handleResize();

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [ref.current]);

  const scroll = (scrollOffset) => {
    ref.current.scrollLeft += scrollOffset;
  };
  const onChangeKeyword = (value) => {
    props.onChangeKeyword(value);
  };

  const searchBySuggest = (keyword) => {
    let values = query;
    // if (
    //   keyword &&
    //   !values.category &&
    //   !values.imageTitle &&
    //   !values.imageId &&
    //   values.color === 'all' &&
    //   !values.creatorName
    // ) {
    //   return toast.warn(t('search_message_not_input'), {
    //     position: toast.POSITION.BOTTOM_RIGHT,
    //     autoClose: 5000,
    //   });
    // }

    values = { ...values };

    let asPath = '';
    forIn(values, (value, key) => {
      if (
        value &&
        key !== 'is_tag' &&
        key !== 'lng' &&
        key !== 'token' &&
        key !== 'clientIp' &&
        key !== 'keyword'
      ) {
        asPath += `&${key}=${value}`;
      }
    });

    LocalStorage.otherServices = null;

    let pageURL = `/search/${keyword}?${asPath}`;
    if (currentLang !== 'en' || props.isLocaleInPath) {
      pageURL = `/${currentLang}${pageURL}`;
    }
    onChangeKeyword(keyword);

    searchPhoto({
      ...values,
      keyword: keyword,
      excludeKeyword: values.excludeKeyword,
      category: values.category,
      excludeCategory: values.excludeCategory,
      creatorName: values.creatorName,
      excludeCreatorName: values.excludeCreatorName,
      color: values.color || 'all',
      modelCount: values.modelCount,
      modelAge: values.modelAge,
      isFromSearchHeader: true,
      // fileType: values.imageType,
      imageType: values.imageType,
      imageId: values.imageId,
      orderBy: values.orderBy,
      shape: values.shape,
      title: values.imageTitle,
      modelRelease: values.modelRelease,
    });
    I18nRouter.push(
      {
        pathname: `/search/${keyword}`,
        locale: currentLang,
        query: {
          ...values,
          keyword: keyword,
          excludeKeyword: values.excludeKeyword,
          category: values.category,
          excludeCategory: values.excludeCategory,
          creatorName: values.creatorName,
          excludeCreatorName: values.excludeCreatorName,
          color: values.color || 'all',
          modelCount: values.modelCount,
          modelAge: values.modelAge,
          isFromSearchHeader: true,
          // fileType: values.imageType,
          imageType: values.imageType,
          imageId: values.imageId,
          orderBy: values.orderBy,
          shape: values.shape,
          title: values.imageTitle,
          modelRelease: values.modelRelease,
        },
      },
      pageURL,
      { shallow: true },
    );
  };
  if (!keywords || keywords.length === 0) {
    return <div className="container-keyword" />;
  }
  return (
    <div className="container-keyword">
      {config.isIllustAC() ? (
        <>
          <div className="keywords-list" ref={ref}>
            {keywords.map((keyword, idx) => (
              <div
                key={`${keyword}-${idx}`}
                onClick={() => searchBySuggest(keyword)}
              >
                <a className="btn btn-keywords-list">
                  <FontAwesomeIcon
                    icon={faMagnifyingGlass}
                    style={{
                      width: '1em',
                      marginRight: '8px',
                      color: '#7A7A7A',
                    }}
                  />
                  {keyword.replace(/\+/g, ' ')}
                </a>
              </div>
            ))}
            {seeMore && (
              <span
                className="see-more-link"
                onClick={() => {
                  setSeeMore(!seeMore);
                  setShowSeeMore(true);
                }}
              >
                {t('see_less_key_word')}
              </span>
            )}
          </div>
          {showSeeMore && !seeMore && (
            <span
              className="see-more-link"
              onClick={() => setSeeMore(!seeMore)}
            >
              {t('design_more_count_down_time')}
            </span>
          )}
        </>
      ) : (
        <>
          <button className="btn btn-prev" onClick={() => scroll(-300)}>
            <FontAwesomeIcon icon={faChevronLeft} style={{ width: '1em' }} />
          </button>
          <div className="keywords-list" ref={ref}>
            {keywords.map((keyword, idx) => (
              <div
                key={`${keyword}-${idx}`}
                // href={`/search-result?keyword=${keyword}&is_tag=true`}
                onClick={() => searchBySuggest(keyword)}
              >
                <a className="btn btn-keywords-list">
                  {keyword.replace(/\+/g, ' ')}
                </a>
              </div>
            ))}
          </div>
          <button className="btn btn-prev" onClick={() => scroll(300)}>
            <FontAwesomeIcon style={{ width: 16 }} icon={faChevronRight} />
          </button>
        </>
      )}

      <style jsx>
        {`
          .container-keyword {
            display: flex;
            ${config.isIllustAC()
              ? `justify-content: space-between;
               align-items: center;
               width: 100%;`
              : `width: calc(100% -  ${
                  config.isDesignAC() || toggleFilterSearch ? 0 : 200
                }px);`}
          }
          .btn {
            border: 1px solid rgba(122, 122, 122, 0.5);
            background: #fff;
            height: 36px;
          }
          .btn-prev {
            color: #c4c4c4;
            outline: none;
            min-width: 44px;
            border: 1px solid #c4c4c4;
            box-sizing: border-box;
            border-radius: 4px;
          }
          .btn-keywords-list {
            color: #000000;
            display: flex;
            flex-direction: row;
            justify-keywords-list: center;
            align-items: center;
            white-space: nowrap;
            ${config.isIllustAC()
              ? 'margin:4px;  font-weight:400; border-radius:40px;'
              : 'margin:0 4px;  font-weight:500; border-radius:4px;'}
          }
          .see-more-link {
            font-weight: 700;
            font-size: 16px;
            line-height: 28px;
            color: #3a4ed7;
            margin-left: 4px;
            width: 90px;
            position: relative;
            top: -4px;
          }
          .see-more-link:hover {
            text-decoration: underline;
            opacity: 0.8;
            cursor: pointer;
          }
          .keywords-list {
            flex: 1;
            display: flex;
            flex-direction: row;
            justify-keywords-list: center;
            align-items: center;
            ${config.isIllustAC()
              ? `flex-wrap:wrap;
              margin: 0 ;
              overflow: hidden;`
              : `scroll-behavior: smooth;
              overflow-x: scroll;
              flex-wrap: nowrap;
              margin: 0 8px;`}
            position: relative;
            scrollbar-width: none;
            max-height: ${seeMore ? 'fit-content' : '45px'};
          }
          .keywords-list::-webkit-scrollbar {
            display: none;
          }
          .btn-keywords-list:hover {
            background: #ecf1f4;
          }
          .btn-keywords-list:active {
            box-shadow: inset 0px 4px 4px rgba(0, 0, 0, 0.25);
          }
          @media (max-width: ${themeVariables.breakpoints.tabletL.maxWidth}px) {
            .container-keyword {
              width: 400px;
              position: relative;
              overflow-x: scroll;
              display: flex;
              scroll-behavior: smooth;
            }
          }
        `}
      </style>
    </div>
  );
};

const mapStateToProps = createStructuredSelector({
  isLocaleInPath: makeSelectIsLocaleInPath(),
});
const mapDispatchToProps = (dispatch) => ({
  onChangeKeyword: (value) => dispatch(changeKeyword(value)),
  searchPhoto: (value) => dispatch(searchPhoto(value)),
});
export default connect(mapStateToProps, mapDispatchToProps)(OtherKeywords);
